import { TimeStampsData } from '@tymbe/schema/src/jsonSchema.utils';
import moment from 'moment';
import { useEffect, useRef } from 'react';

const useOutsideClick = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [callback]);

  return ref;
};

export default useOutsideClick;

export const isDeleted = <T extends TimeStampsData>(entity: T) => moment(entity.deleted_at).isBefore();
export const notDeleted = <T extends TimeStampsData>(entity: T) => !isDeleted(entity);
